import { action, observable } from 'mobx';
import type { WebmixerOrderSummary } from '@triplabo/web/services';

export class Order {
  @observable accessor summaries: WebmixerOrderSummary[] = [];

  @action
  setSummaries(summaries: WebmixerOrderSummary[]) {
    this.summaries = summaries;
  }
}

const order = new Order();

export default order;
